import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert, LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function ImpersonationBanner() {
  const { impersonatedBy, user, stopImpersonation } = useAuth();
  const navigate = useNavigate();

  if (!impersonatedBy || !user) return null;

  const handleStop = () => {
    stopImpersonation();
    navigate('/admin');
  };

  const adminName = `${impersonatedBy.first_name || ''} ${impersonatedBy.last_name || ''}`.trim() || impersonatedBy.email || 'Admin';
  const userName = `${user.first_name || ''} ${user.last_name || ''}`.trim() || user.email || 'User';

  return (
    <div
      data-testid="impersonation-banner"
      className="sticky top-0 z-[60] w-full bg-gradient-to-r from-amber-500 via-amber-400 to-amber-500 text-[#0B0B0B] shadow-lg"
    >
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2 min-w-0">
          <ShieldAlert className="w-5 h-5 shrink-0" strokeWidth={2.5} />
          <p className="text-sm font-bold leading-tight truncate">
            Impersonation mode &middot; Viewing as <span className="underline decoration-2 underline-offset-2">{userName}</span>
            <span className="hidden sm:inline"> &middot; signed in by <strong>{adminName}</strong></span>
          </p>
        </div>
        <button
          type="button"
          onClick={handleStop}
          data-testid="stop-impersonation-btn"
          className="inline-flex items-center gap-1.5 bg-[#0B0B0B] hover:bg-black text-amber-400 text-xs font-extrabold uppercase tracking-wider px-3 py-1.5 rounded-lg transition shrink-0"
        >
          <LogOut className="w-3.5 h-3.5" />
          Stop impersonating
        </button>
      </div>
    </div>
  );
}
